import React from 'react';

const ChatInput = ({
  input,
  setInput,
  handleKeyDown,
  handleSendMessage,
  isLoading,
  disabledReason,
}) => {
  const isDisabled = Boolean(isLoading || disabledReason);
  const placeholder = disabledReason || (isLoading ? 'Sending message...' : 'Type your message here...');
  const showSpinner = Boolean(isLoading);

  return (
    <div className="w-full flex items-center space-x-4">
      <textarea
        rows={2}
        className="min-w-0 flex-grow resize-y p-3 bg-gray-700 bg-opacity-70 rounded-full border-none focus:outline-none focus:ring-2 focus:ring-blue-400 placeholder-gray-400 text-white disabled:opacity-50"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={isDisabled}
        aria-disabled={isDisabled}
        aria-label={isDisabled ? `Chat input disabled: ${placeholder}` : 'Chat input'}
      />
      <button
        className="p-3 bg-blue-600 rounded-full text-white focus:outline-none focus:ring-2 focus:ring-blue-400 hover:bg-blue-700 transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
        type="submit"
        onClick={handleSendMessage}
        disabled={isDisabled}
        aria-disabled={isDisabled}
        aria-label={isDisabled ? 'Chat action disabled' : 'Send message'}
      >
        {showSpinner ? (
          <svg className="h-6 w-6 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 transform rotate-90" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default ChatInput;
